export default "__VITE_ASSET__7d9a5ab1__"